import { z } from 'zod';

export const mcpAuthorizationSearch = z
  .object({
    request: z.string().regex(/^[0-9a-f]{64}$/),
  })
  .strict();

export interface McpAuthorizationRequest {
  clientId: 'vision-lab-operation';
  resource: string;
  redirectUri: string;
}

export interface McpAuthorizationConfirmation {
  redirectUrl: string;
}
